(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency
    }).format((parseInt(cents || '0', 10) || 0) / 100);
  }

  function updateStickyBuy(quantity) {
    var qty = Math.max(1, parseInt(quantity || '1', 10));

    qsa('[data-sticky-qty]').forEach(function (stickyInput) {
      stickyInput.value = qty;
    });

    qsa('[data-sticky-qty-label]').forEach(function (label) {
      label.textContent = qty + (qty === 1 ? ' item' : ' items');
    });

    qsa('[data-sticky-price]').forEach(function (price) {
      var unitPrice = parseInt(price.getAttribute('data-unit-price-cents') || '0', 10);
      var bundlePrice = parseInt(price.getAttribute('data-bundle-price-cents') || '0', 10);
      var total = qty === 2 && bundlePrice ? bundlePrice : unitPrice * qty;
      price.textContent = formatMoney(total);
    });
  }

  function setupMenu() {
    qsa('[data-menu-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        document.body.classList.toggle('menu-open');
      });
    });
  }

  function setupGallery(root) {
    qsa('[data-product-gallery]', root).forEach(function (gallery) {
      var mainImage = qs('[data-main-image]', gallery);
      if (!mainImage) return;

      qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-gallery-src');
          var alt = thumb.getAttribute('data-gallery-alt') || '';
          if (!src) return;

          mainImage.setAttribute('src', src);
          mainImage.setAttribute('alt', alt);
          qsa('[data-gallery-thumb]', gallery).forEach(function (item) {
            item.classList.toggle('is-active', item === thumb);
          });
        });
      });
    });
  }

  function setupQuantity(root) {
    qsa('[data-qty]', root).forEach(function (wrap) {
      var input = qs('input', wrap);
      if (!input) return;

      function syncStickyQuantity() {
        if (input.getAttribute('name') !== 'quantity') return;
        updateStickyBuy(input.value);
      }

      qsa('button', wrap).forEach(function (button) {
        button.addEventListener('click', function () {
          var next = parseInt(input.value || '1', 10);
          if (button.getAttribute('data-qty-action') === 'minus') next -= 1;
          if (button.getAttribute('data-qty-action') === 'plus') next += 1;
          input.value = Math.max(1, next);
          syncStickyQuantity();
        });
      });

      input.addEventListener('change', syncStickyQuantity);
    });
  }

  function setupCartQuantity(root) {
    function submitCart(input) {
      var form = input.closest('form');
      if (!form) return;
      var updateButton = qs('.nf-update-cart', form);

      if (form.requestSubmit) {
        form.requestSubmit(updateButton || undefined);
      } else {
        form.submit();
      }
    }

    qsa('.nf-cart-qty', root).forEach(function (wrap) {
      var input = qs('input', wrap);
      if (!input) return;

      var minus = qs('[data-cart-minus]', wrap);
      var plus = qs('[data-cart-plus]', wrap);

      if (minus) {
        minus.addEventListener('click', function () {
          input.value = Math.max(0, parseInt(input.value || '1', 10) - 1);
          submitCart(input);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
          submitCart(input);
        });
      }

      input.addEventListener('change', function () {
        input.value = Math.max(0, parseInt(input.value || '0', 10));
        submitCart(input);
      });
    });
  }

  function setupPackSelector(root) {
    qsa('[data-pack-selector]', root).forEach(function (selector) {
      if (selector.dataset.packReady === 'true') return;
      selector.dataset.packReady = 'true';

      var form = selector.closest('.nf-product-info').querySelector('form[action*="/cart/add"]');
      var qtyInput = form && form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      function setPackQuantity(value) {
        var quantity = value === 'two' ? '2' : '1';
        qtyInput.value = quantity;
        updateStickyBuy(quantity);
      }

      qsa('input[name="nf-pack"]', selector).forEach(function (input) {
        input.addEventListener('change', function () {
          setPackQuantity(input.value);
        });
      });

      var checked = qs('input[name="nf-pack"]:checked', selector);
      if (checked) setPackQuantity(checked.value);
    });
  }

  function setupStickyBuyVisibility(root) {
    qsa('.nf-product-page', root).forEach(function (page) {
      if (page.dataset.stickyBuyReady === 'true') return;
      page.dataset.stickyBuyReady = 'true';

      var sticky = qs('.nf-sticky-buy', page);
      if (!sticky) return;

      function updateVisibility() {
        var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        var progress = window.scrollY / scrollable;
        sticky.classList.toggle('is-active', progress >= 0.5);
      }

      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    });
  }

  function setupCartDiscountPopup(root) {
    qsa('[data-cart-discount-popup]', root).forEach(function (popup) {
      if (popup.dataset.discountReady === 'true') return;
      popup.dataset.discountReady = 'true';

      if (window.sessionStorage && sessionStorage.getItem('nfDiscountPopupClosed') === 'true') return;

      var countdown = qs('[data-discount-countdown]', popup);
      var close = qs('[data-discount-close]', popup);
      var secondsLeft = 5 * 60;

      function renderTimer() {
        var minutes = Math.floor(secondsLeft / 60);
        var seconds = secondsLeft % 60;
        if (countdown) {
          countdown.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
        }
      }

      function hidePopup() {
        popup.hidden = true;
        if (window.sessionStorage) sessionStorage.setItem('nfDiscountPopupClosed', 'true');
      }

      setTimeout(function () {
        popup.hidden = false;
        renderTimer();
      }, 650);

      var timer = setInterval(function () {
        secondsLeft -= 1;
        renderTimer();
        if (secondsLeft <= 0) clearInterval(timer);
      }, 1000);

      if (close) {
        close.addEventListener('click', hidePopup);
      }
    });
  }

  function setupHeroSlider(root) {
    qsa('[data-hero-slider]', root).forEach(function (slider) {
      if (slider.dataset.heroReady === 'true') return;
      slider.dataset.heroReady = 'true';

      var slides = qsa('[data-hero-slide]', slider);
      var dots = qsa('[data-hero-dots] span', slider);
      var index = 0;
      if (slides.length <= 1) return;

      function activate(nextIndex) {
        index = nextIndex % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () {
          activate(dotIndex);
        });
      });

      activate(0);
      setInterval(function () {
        activate(index + 1);
      }, 4200);
    });
  }

  function setupReviewCarousel(root) {
    qsa('[data-review-carousel]', root).forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      var cards = qsa('.nf-review-card', carousel);
      var index = 0;
      if (cards.length <= 1) return;

      function visibleCount() {
        var cardWidth = cards[0].getBoundingClientRect().width;
        if (!cardWidth) return 1;
        return Math.max(1, Math.floor(carousel.clientWidth / cardWidth));
      }

      function activate(nextIndex) {
        var maxIndex = Math.max(0, cards.length - visibleCount());
        index = maxIndex === 0 ? 0 : nextIndex % (maxIndex + 1);
        carousel.scrollTo({
          left: cards[index].offsetLeft - carousel.offsetLeft,
          behavior: 'smooth'
        });
      }

      setInterval(function () {
        activate(index + 1);
      }, 3200);
    });
  }

  function setupProductReveal(root) {
    qsa('.nf-product-page', root).forEach(function (page) {
      if (page.dataset.revealReady === 'true') return;
      page.dataset.revealReady = 'true';

      var items = qsa(':scope > *:not(.nf-sticky-buy)', page);
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (item, itemIndex) {
        item.classList.add('nf-reveal-item');
        item.style.transitionDelay = Math.min(itemIndex * 45, 240) + 'ms';
        observer.observe(item);
      });
    });
  }

  function init(root) {
    setupHeroSlider(root || document);
    setupReviewCarousel(root || document);
    setupProductReveal(root || document);
    setupGallery(root || document);
    setupQuantity(root || document);
    setupCartQuantity(root || document);
    setupPackSelector(root || document);
    setupStickyBuyVisibility(root || document);
    setupCartDiscountPopup(root || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupMenu();
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
